import { Component, HostListener } from '@angular/core';
import { ComponentCanDeactivate } from '../guards/unsaved-changes.guard';

@Component({
    selector: 'wfdss-unsaved-changes',
    templateUrl: './unsaved-changes.component.html',
    styleUrls: ['./unsaved-changes.component.scss'],
    standalone: false
})
export class UnsavedChangesComponent implements ComponentCanDeactivate {


  constructor() { }

  @HostListener('window:beforeunload')
  canDeactivate() {
    return false;
  }

}
